import { gql } from "urql";

export const DEVICE_FIRMWARE_LIST = gql`
  query DeviceFirmwareList($input: DeviceFirmwareListInput!) {
    deviceFirmwareList(input: $input) {
      data {
        id
        modelName
        versionNumber
        versionName
        targetVersionName
        classification
        fileName
        fileSize
        fileUrl
        checksum
        description
        createdAt
        updatedAt
      }
    }
  }
`;
